import React, { useState, useEffect, useRef } from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import ReactMapGL, { Marker } from 'react-map-gl'
import Modal from 'react-modal'

import '../assets/css/motivate.css'
import '../assets/css/mapbox.css'

import BannerTeam from '../components/BannerTeam'


import poster from '../assets/images/motivate/outreach.png'
import outreach2025 from '../assets/images/motivate/outreach2025.png'


const style = {
    width: '90vw',
    height: 'auto',
    // borderRadius: '10px',
    // borderStyle: 'solid',
    // borderColor: 'white',
    // borderWidth: '8px'
    boxShadow: '#131520 0 0 20px 10px',
}

export default function HandBook() {
    return (
        <div>
            <Layout>
                <Helmet>
                    <title>Krypton Warriors</title>
                    <meta name="description" content="Landing Page" />
                    <script defer src='https://static.cloudflareinsights.com/beacon.min.js' data-cf-beacon='{"token": "53ca0e93ef80463192e735fa104fef39"}'></script>
                </Helmet>

                <BannerTeam />
                <div id="main">
                    <section id="one">
                        <div className="inner">
                            <header className="major">
                                <h2>Hand Book</h2>
                            </header>
                            <h3>Krypton Warriors / 16367</h3>
                            <h4>Mission</h4>
                            <p>
                                To design, build, and program competitive robots while promoting STEM education,
                                teamwork, and leadership in our community.
                            </p>
                            <h4>Team</h4>
                            <ul>
                                <li>2 Coaches: Adults (18+) who provide guidance and manage logistics.</li>
                                <li>Mentors: Adults (18+) who teach, advise, and ensure safety without doing the work themselves.</li>
                                <li>Team Captains: Student leaders responsible for coordinating sub-teams and reporting progress.
                                    <ul>
                                        <li>Sub-teams: Design / Build / Programming / Outreach / Logistics / Driving Team</li>
                                    </ul>
                                </li>
                                <li>Shared Funds/Equipment: All tools, parts, and funds remain property of the team.</li>
                                <li>Fundraising: Every member participates in outreach and fundraising events.</li>
                            </ul>
                            <h4>Membership & Commitment</h4>
                            <ul>
                                <li>Students who miss more than 2 unexcused meetings will lose team privileges, including competition participation.</li>
                                <li>Students are expected to actively contribute in at least one subteam rather than participating only in name.</li>
                                <li>Students are expected to follow the team captain/coach directions at all times.</li>
                                <li>Students may express interest in a particular activity, but final placement will be made in the interest of the team.</li>
                                <li>Decisions made by captains/coaches are final and not subject to debate.</li>
                            </ul>

                            <h4>Safety</h4>
                            <ul>
                                <li>Each team member is responsible for their own safety and the safety of those around them.</li>
                                <li>No running, horseplay, or unsafe behavior. Model Gracious Professionalism.</li>
                            </ul>

                            <h4>Communication</h4>
                            <ul>
                                <li>Team captains will decide the communication channels/modes as appropriate with the team.</li>
                                <li>Parents use WhatsApp for general information sharing.</li>
                            </ul>

                            <h4>Parents</h4>
                            <ul>
                                <li>Parents can best support the team by helping with roles carried out by adults such as outreach efforts, event organization, and FTC event participation.</li>
                                <li>Parents are encouraged to serve as a team mentor.</li>
                                <li>Students are expected to champion themselves; parents should not intervene in team matters.</li>
                                <li>Parents should check in with their student or coaches for any updates and information.</li>
                                <li>Parents are asked to refrain from directly reaching out to team captains.</li>
                            </ul>
                            <h4>Acknowledgment</h4>
                            <p>By joining this team, each member agrees to:</p>
                            <ul>
                                <li>Follow the rules and expectations outlined.</li>
                                <li>Represent the team with professionalism at all times.</li>
                                <li>Work collaboratively toward team goals.</li>
                                <li>Respect and accept the final decision made by team captains/coaches.</li>
                            </ul>
                        </div>
                    </section>
                </div>
            </Layout>
        </div>
    )
}
